<template>
  <div class="mt-8 mx-8 pa-4" v-if="!loading">
    <img v-if="mime === 'image'"
         :src="file.url" class="image-lesson"
         :alt="file.name">
    <audio v-else-if="mime === 'audio'"
           :src="file.url" controls style="width: 100%"></audio>
    <video width="800" height="800" :src="file.url" controls v-else-if="mime === 'video'"></video>
    <video-player :options="videoOptions" source="ShowFileComponent"
                  v-else-if="mime === 'm3u8'">
    </video-player>
    <v-btn v-else style="letter-spacing: normal" width="100%"
           color="primary"
           @click="goTo(file.url)">مشاهده
    </v-btn>
  </div>
</template>

<script>
import VideoPlayer from "@/components/Player/VideoPlayer.vue";

export default {
  name: "ShowFile",
  components: {VideoPlayer},
  data() {
    return {
      loading: true,
      file: {
        url: null
      },
      mime: null,
      videoOptions: {
        autoplay: true,
        playbackRates: [0.5, 1, 1.5, 2, 4, 8],
        controls: true,
        liveui: true,
        responsive: true,
        sources: [
          {
            src: 'http://localhost:8000/storage/dorak/lesson_file/test/hls/2023-11-01/akbar',
            type: "application/vnd.apple.mpegurl"
          }
        ],
      },
    }
  },
  mounted() {
    this.getFile()
  },
  methods: {
    getFile() {
      window.axios.get('file-manager/get-data-id/' + this.$route.params.id).then((res) => {
        this.file = res.data.data
        this.file.url = process.env.VUE_APP_BASE_URL_DEFAULT + res.data.data.url
        this.loading = false
        let videosMime = ['mp4', 'MP4', 'WMV', 'wmv', 'mkv', 'flv', 'FLV', 'MKV', 'AVI', 'avi', '3gp', '3GP', 'mov', 'MOV'];
        // let m3u8Mime = ['m3u8', 'M3U8', 'ts', 'TS'];
        let imagesMime = ['jpg', 'JPG', 'jpeg', 'JPEG', 'png', 'PNG', 'svg', 'SVG', 'gif', 'GIF', 'tiff', 'TIFF', 'psd', 'PSD'];
        let audiosMime = ['mp3', 'MP3', 'audio', 'AUDIO', 'aac', 'AAC', 'ogg', 'OGG', 'wav', 'WAV', 'flac', 'FLAC', 'aiff', 'AIFF'];
        // str.substring(str.indexOf("begin:")+6).trim()
        if (this.file.url.includes('.m3u8')) {
          this.videoOptions.sources[0].src = this.file.url
          this.mime = 'm3u8'
        } else if (videosMime.includes(this.file.url)) {
          this.mime = 'video'
        } else if (imagesMime.includes(this.file.mime)) {
          this.mime = 'image'
        } else if (audiosMime.includes(this.file.mime)) {
          this.mime = 'audio'
        }
        console.log(res.data.data)
        console.log(this.mime)
      })
    },
    goTo(url) {
      window.open(url)
    }
  }
}
</script>

<style scoped>

</style>